export const UPLOAD_STATUS_NOT_UPLOADING = 'not uploading';
export const UPLOAD_STATUS_UPLOADING = 'uploading';
export const UPLOAD_STATUS_COMPLETED = 'completed';
